import React from 'react'
import {
    SelectField,
    FileUpload,
    InputField,
    RadioField,
    DatePickerField,
    PhoneCountryField
} from 'components/CustomFields'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import formModel from 'containers/Onboarding/FormModels/Models';
import {
    EMPLOYMENT_STATUS,
    EMPLOYMENT_STATUS_OPTIONS,
    OCCUPATION_ROLE,
    OCCUPATION_ROLE_OPTIONS,
    OCCUPATION_INDUSTRY,
    OCCUPATION_INDUSTRY_OPTIONS,
    WORKING_DURATION_OPTIONS,
} from 'constants/Options/options'
import ListCountry from 'constants/Countries/countries'
import {
    useAddress
} from 'hooks/useKYC'
import { useFormikContext } from 'formik'
import dataStorage from 'dataStorage';

const { formField } = formModel

const EmploymentInformation = () => {
    const { values } = useFormikContext();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <SelectField
                    required
                    name={formField.employment_information.employment_status.name}
                    label={formField.employment_information.employment_status.label}
                    data={EMPLOYMENT_STATUS_OPTIONS}
                    fullWidth
                />
            </Grid>
            {
                values?.employment_information?.employment_status === EMPLOYMENT_STATUS.OTHER
                    ? <Grid item xs={12}>
                        <InputField
                            required
                            maxLength={200}
                            name={formField.employment_information.employment_status_desc.name}
                            label={formField.employment_information.employment_status_desc.label}
                            fullWidth
                        />
                    </Grid>
                    : <React.Fragment />
            }
            {
                values?.employment_information?.employment_status === EMPLOYMENT_STATUS.RETIRED
                    ? <React.Fragment />
                    : <React.Fragment>
                        <Grid item xs={12}>
                            <InputField
                                required
                                maxLength={200}
                                name={formField.employment_information.employer_name.name}
                                label={formField.employment_information.employer_name.label}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField
                                required
                                name={formField.employment_information.occupation_role.name}
                                label={formField.employment_information.occupation_role.label}
                                data={OCCUPATION_ROLE_OPTIONS}
                                fullWidth
                            />
                        </Grid>
                        {
                            values?.employment_information?.occupation_role === OCCUPATION_ROLE.OTHER
                                ? <Grid item xs={12}>
                                    <InputField
                                        required
                                        maxLength={200}
                                        name={formField.employment_information.occupation_role_desc.name}
                                        label={formField.employment_information.occupation_role_desc.label}
                                        fullWidth
                                    />
                                </Grid>
                                : <React.Fragment />
                        }
                        <Grid item xs={12}>
                            <SelectField
                                required
                                name={formField.employment_information.occupation_industry.name}
                                label={formField.employment_information.occupation_industry.label}
                                data={OCCUPATION_INDUSTRY_OPTIONS}
                                fullWidth
                            />
                        </Grid>
                        {
                            values?.employment_information?.occupation_industry === OCCUPATION_INDUSTRY.OTHERS
                                ? <Grid item xs={12}>
                                    <InputField
                                        required
                                        maxLength={200}
                                        name={formField.employment_information.occupation_industry_desc.name}
                                        label={formField.employment_information.occupation_industry_desc.label}
                                        fullWidth
                                    />
                                </Grid>
                                : <React.Fragment />
                        }
                        <Grid item xs={12}>
                            <SelectField
                                required
                                name={formField.employment_information.working_duration.name}
                                label={formField.employment_information.working_duration.label}
                                data={WORKING_DURATION_OPTIONS}
                                fullWidth
                            />
                        </Grid>
                    </React.Fragment>
            }
        </Grid>
    )
}

export default EmploymentInformation